/**
 * Organization onboarding gate — single source of truth shared by the post-login
 * redirect (getHomeRoute / MagicLinkCallback) and the route guard
 * (RequireOrganizationSetup).
 */
export const isOrganizationSetupComplete = (user) => {
  const t = user?.tenant;
  if (!t) return false;

  if (t.organization_profile_completed === true) return true;

  const derivedComplete = Boolean(t.name && (t.phone || t.mobile_number || t.organization_type));
  const incomplete = t.organization_profile_completed === false || (t.organization_profile_completed == null && !derivedComplete);

  return !incomplete;
};

export const requiresOrganizationSetup = (user) => {
  // Organisation onboarding intent: the creator's role is only granted after
  // the organisation exists and they are attached, so a soft account must be
  // recognised by onboarding_type (scoped to soft/welcome so parent flows,
  // which also use onboarding_type='organization', are unaffected).
  const isOrgAdmin = user?.role === 'organization_admin'
    || Boolean(user?.is_organization_admin)
    || (user?.onboarding_type === 'organization' && (user?.is_soft_account || user?.onboarding_step === 'welcome'));
  if (!isOrgAdmin) return false;

  // Soft accounts / welcome state always require onboarding.
  if (user?.is_soft_account || user?.onboarding_step === 'welcome') return true;

  // Pivot-only org admins have no user-level tenant: their organisation
  // context is resolved from the URL slug / organisation list, not from the
  // onboarding wizard. Do not force them through onboarding.
  if (!user?.tenant) return false;

  return !isOrganizationSetupComplete(user);
};
